"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendarGridTokens = void 0;
var _globalTokens = require("../../../../shared/global-tokens");
var calendarGridTokens = function calendarGridTokens(theme) {
  return {
    color: {
      font: {
        default: theme.sys.color.text.content.primary,
        selection: theme.sys.color.text.content.primary,
        selectionEdge: theme.sys.color.text.content.ondark,
        focus: theme.sys.color.text.content.primary,
        disabled: theme.sys.color.text.disabled
      },
      background: {
        default: 'inherit',
        selection: theme.sys.color.background.primary['1'],
        selectionEdge: theme.sys.color.background.primary['3'],
        focus: theme.sys.color.background.primary['3'],
        disabled: theme.sys.color.background.disabled['1']
      },
      border: theme.sys.color.border.separator,
      highlight: {
        default: theme.sys.color.background.primary['3'],
        onDark: theme.sys.color.background.primary['1']
      }
    },
    border: {
      radius: {
        singleSelection: "".concat(theme.sys.size.borderradius['2'], ";"),
        selectionStart: "".concat(theme.sys.size.borderradius['2'], " 0 0 ").concat(theme.sys.size.borderradius['2'], ";"),
        selectionEnd: "0 ".concat(theme.sys.size.borderradius['2'], " ").concat(theme.sys.size.borderradius['2'], " 0;")
      }
    },
    size: {
      cell: {
        height: "".concat(_globalTokens.globalSizing['1100']),
        width: "".concat(_globalTokens.globalSizing['1100'])
      }
    }
  };
};
exports.calendarGridTokens = calendarGridTokens;